import { useEffect } from 'react'
import { useMutation } from '@apollo/client'
import TRACK_ADBLOCKER_DETECTED from 'Apollo/Mutations/TrackAdblockerDetected'
import { useAuth0 } from '@auth0/auth0-react'

export const useDetectAdblockerEvent = () => {
  const segmentAnalyticsErrored = window.analytics.errored
  const [trackAdblockerDetected] = useMutation(TRACK_ADBLOCKER_DETECTED)
  const { isAuthenticated } = useAuth0()

  useEffect(() => {
    if (segmentAnalyticsErrored && isAuthenticated) {
      trackAdblockerDetected()
    }
  }, [segmentAnalyticsErrored, trackAdblockerDetected, isAuthenticated])
}
